<template>
  <v-dialog
    v-model="showThemePreview"
    fullscreen
    @keydown.esc="showThemePreview = false"
  >
    <v-card v-if="showThemePreview">
      <v-app-bar :clipped-right="true" :clipped-left="true" fixed>
        <div>
          <img
            v-if="profileDetail && profileDetail.logo"
            contain
            aspect-ratio="1"
            height="30"
            class="pl-6"
            alt="Brand Logo"
            :src="profileDetail.logo"
          />
          <div v-else>
            <img
              contain
              aspect-ratio="1"
              height="30"
              class="pl-6"
              alt="Brand Logo"
              :src="$globalConstant.logo"
            />
          </div>
        </div>

        <v-spacer></v-spacer>
        <UserNotification v-model="openNotifications" />
        <div class="d-flex algin-center ml-2">
          <div class="px-3">
            <h6
              class="primary--text text-uppercase text-body-2 font-weight-bold pa-0 ma-0"
            >
              {{ profileDetail.first_name }} {{ profileDetail.last_name }}
            </h6>

            <h6
              class="grey--text text-caption font-weight-bold pa-0 ma-0 text-capitalize"
              v-if="profileDetail && profileDetail.role"
            >
              {{ profileDetail.role.replace(/_/g, " ") }}
            </h6>
          </div>
        </div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="250"
          min-width="200px"
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon depressed v-bind="attrs" v-on="on">
              <v-img
                class="mx-5 pr-4 profile-image"
                contain
                style="height: 50px !important; width: 50px !important"
                :src="$globalConstant.profileImage"
                alt="User"
              />
            </v-btn>
          </template>
          <v-card elevation="0" width="auto" min-width="300">
            <v-row no-gutters>
              <v-col cols="4" class="text-center py-3 px-0">
                <v-img
                  class="mx-5 pr-4 profile-image"
                  style="height: 50px !important; width: 50px !important"
                  contain
                  :src="
                    profileDetail && profileDetail.profile_image
                      ? profileDetail.profile_image
                      : $globalConstant.profileImage
                  "
                  alt="User"
                />
              </v-col>
              <v-col cols="8" class="d-flex flex-column justify-center">
                <h5
                  class="primary--text text-capitalize d-flex justify-space-between"
                >
                  <span>
                    {{ profileDetail.first_name }}
                    {{ profileDetail.last_name }}
                  </span>
                  <span class="pr-6">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          small
                          @click="openProfileDialog = true"
                        >
                          mdi-eye
                        </v-icon>
                      </template>
                      <span class="text-capitalize text-no-wrap">Profile</span>
                    </v-tooltip>
                  </span>
                </h5>
                <h5
                  class="text-body-2 font-weight-light"
                  v-if="profileDetail.role"
                >
                  {{ profileDetail.role.replace(/_/g, " ") }}
                </h5>
              </v-col>
            </v-row>

            <v-card-text class="px-8 pt-0">
              <div class="d-flex my-2" v-if="profileDetail.username">
                <div>
                  <v-icon small class="mr-4 primary--text">mdi-account</v-icon>
                </div>
                <div>
                  <span class="text-caption">
                    <BaseTooltip
                      :text="profileDetail.username"
                      title="username"
                    />
                  </span>
                </div>
              </div>
              <div class="d-flex my-2" v-if="profileDetail.company_name">
                <div>
                  <v-icon small class="mr-4 primary--text">mdi-domain</v-icon>
                </div>
                <div>
                  <span class="text-caption">
                    <BaseTooltip
                      :text="profileDetail.company_name"
                      title="Company Name"
                    />
                  </span>
                </div>
              </div>
              <div class="d-flex my-2" v-if="profileDetail.contact_number">
                <div>
                  <v-icon small class="mr-4 primary--text">mdi-phone</v-icon>
                </div>
                <div>
                  <span class="text-caption">
                    <BaseTooltip
                      :text="profileDetail.contact_number"
                      title="contact number"
                    />
                  </span>
                </div>
              </div>

              <div class="d-flex my-2" v-if="profileDetail.email">
                <div>
                  <v-icon small class="mr-4 primary--text">mdi-email</v-icon>
                </div>
                <div>
                  <span class="text-caption">
                    <BaseTooltip
                      :text="profileDetail.email"
                      title="contact Email"
                    />
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-text class="pa-0">
              <v-list>
                <v-list-item>
                  <v-icon class="pr-3">mdi-key</v-icon>
                  <span class="pl-2 text-capitalize">Change Password</span>
                </v-list-item>
                <v-list-item>
                  <v-icon class="pr-3">mdi-logout</v-icon>
                  <span class="pl-2 text-capitalize">logout</span>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-app-bar>
      <v-navigation-drawer
        v-if="showThemePreview"
        :color="themeObject.primary"
        width="300"
        class="navigation-shadow"
        style="z-index: 11 !important"
        clipped
        app
      >
        <v-list dense>
          <v-list-item v-for="(item, i) in sideNav" :key="i" class="pa-0 ma-0">
            <v-list-group
              v-if="item && item.subLinks && item.subLinks.length > 0"
              class="w-100 v-list-sub-group white--text"
            >
              <template v-slot:activator>
                <v-list-item class="border-bottom-maroon" router exact>
                  <v-list-item-action class="mr-2">
                    <v-icon class="text-h6 font-weight-light">
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title style="text-transform: capitalize">
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <v-list-item
                router
                exact
                v-for="(subItem, index) in item.subLinks"
                :key="index"
                class="primary darken-1"
              >
                <v-list-item-action class="mr-2">
                  <v-icon class="text-h6 font-weight-light">
                    {{ subItem.icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="text-transform: capitalize">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item v-else class="border-bottom-maroon" router exact>
              <v-list-item-action class="mr-2">
                <v-icon class="text-h6 font-weight-light">{{
                  item.icon
                }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title style="text-transform: capitalize">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main style="padding: 64px 0px 0px 300px; position: relative">
        <v-alert prominent type="info"
          >This is a Theme Preview. Press 'Esc' to close the Theme Preview
          <template #close>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  v-on="on"
                  v-bind="attrs"
                  @click="showThemePreview = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Close Preview</span>
            </v-tooltip>
          </template>
        </v-alert>
        <v-container
          fluid
          class="pa-0"
          style="height: 100% !important; position: absolute"
        >
          <v-row class="ma-0">
            <v-col cols="12">
              <span class="text-h5 font-weight-bold">Theme Preview</span>
            </v-col>
            <v-col cols="12">
              <span class="text-h6">Fields</span>
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="number"
                label="Number Field"
                outlined
                dense
                :color="themeObject.primary"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                label="Input Field"
                :color="themeObject.primary"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                :color="themeObject.primary"
                label="Select"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                @click="menu2 != menu2"
                @change="$emit('change')"
                min-width="auto"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Select Date"
                    hide-details="auto"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="{ ...attrs, ...$attrs }"
                    v-on="{ ...on, $listeners }"
                    v-on:click:append="menu2 = true"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  v-bind="$attrs"
                  v-on="$listeners"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <span class="text-h6">Buttons</span>
            </v-col>
            <v-col>
              <v-btn :color="themeObject.primary" depressed
                >Primary</v-btn
              >
            </v-col>
            <v-col>
              <v-btn :color="themeObject.error" depressed
                >Error</v-btn
              >
            </v-col>
            <v-col>
              <v-btn :color="themeObject.success" depressed
                >Success</v-btn
              >
            </v-col>
            <v-col>
              <v-btn :color="themeObject.warning" depressed
                >Warning</v-btn
              >
            </v-col>
            <v-col>
              <v-btn :color="themeObject.info" depressed
                >Info</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientDefault from "@/layouts/ClientDefault.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import UserNotification from "@/components/BaseComponents/UserNotification.vue";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    themeObject: {
      type: Object,
    },
    profileDetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showThemePreview: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: { ClientDefault, UserNotification, BaseTooltip },
  data() {
    return {
      openNotifications: false,
      menu: false,
      menu2: false,
      date: null,

      sideNav: [
        {
          icon: "mdi-chart-scatter-plot",
          title: "Preview",
          name: "preview",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.profile-image {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
}
</style>
